import { render, staticRenderFns } from "./oneStopProcessingTemplate.vue?vue&type=template&id=9c6a6312&scoped=true&"
import script from "./oneStopProcessingTemplate.vue?vue&type=script&lang=js&"
export * from "./oneStopProcessingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./oneStopProcessingTemplate.vue?vue&type=style&index=0&id=9c6a6312&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6a6312",
  null
  
)

export default component.exports